import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "body-div"
};
var _hoisted_2 = {
  class: "body-right"
};
var _hoisted_3 = {
  class: "mar-b title"
};
var _hoisted_4 = {
  class: "mar-b"
};
var _hoisted_5 = {
  class: "mar-b"
};
var _hoisted_6 = {
  class: "mar-b"
};
var _hoisted_7 = {
  class: "lick-box"
};
var _hoisted_8 = {
  class: "footer"
};
import { ref, onMounted, toRefs } from 'vue';
import { ChevronLeftCircleIcon, ChevronRightCircleIcon } from 'tdesign-icons-vue-next';
import preview from '@/components/FilePreview/Preview';
import { MessagePlugin } from 'tdesign-vue-next';
import { getShowDetail, giveALike } from '@/api/spaceInfo.js';
export default {
  __name: 'detailDialog',
  props: /*@__PURE__*/_mergeModels({
    data: {
      type: Object
    }
  }, {
    "visible": {
      default: false
    },
    "visibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['upload'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var visible = _useModel(__props, 'visible'); // 是否显示弹框
    var props = __props;
    var _toRefs = toRefs(props),
      data = _toRefs.data;
    var emit = __emit;
    var list = ref([]); //课堂展示数据列表
    var currentIndex = ref(0);
    var currentData = ref({}); //当前展示数据
    var detail = ref({}); // 课堂互动数据详情

    // 上一个
    var handlePre = function handlePre() {
      if (!currentIndex.value) return MessagePlugin.info('已经是第一张了！');
      currentIndex.value -= 1;
      currentData.value = list.value[currentIndex.value];
    };
    // 下一个
    var handleNext = function handleNext() {
      if (currentIndex.value === list.value.length - 1) return MessagePlugin.info('已经是最后一张了！');
      currentIndex.value += 1;
      currentData.value = list.value[currentIndex.value];
    };
    //获取详情
    var getDetail = function getDetail() {
      var _data$value = data.value,
        userId = _data$value.userId,
        lessonId = _data$value.lessonId;
      getShowDetail(userId, lessonId).then(function (res) {
        list.value = res.data.data;
        currentData.value = list.value[0];
        detail.value = list.value[0];
      });
    };
    // 点赞
    var handleLike = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var opType;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                opType = Number(item.isLike) ? '0' : '1';
                giveALike(item.id, '2', opType);
                item.isLike ? item.isLike = 0 : item.isLike = 1;
                item.isLike ? item.likeCount -= 1 : item.likeCount += 1;
                MessagePlugin.success('操作成功');
                emit('upload');
              } catch (error) {
                MessagePlugin.error('操作失败');
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleLike(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getDetail();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        width: "90vw",
        title: "课堂互动详情",
        "close-btn": "",
        footer: false,
        class: "lesson-dialog",
        closeOnOverlayClick: ""
      }, {
        default: _withCtx(function () {
          var _currentData$value;
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(preview), {
            path: currentData.value.fileUrl,
            class: "preview-box"
          }, null, 8, ["path"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(detail.value.subjectName), 1), _createElementVNode("div", _hoisted_4, "授课老师：" + _toDisplayString(detail.value.name), 1), _createElementVNode("div", _hoisted_5, "参加互动：" + _toDisplayString(detail.value.interactionCount) + "次", 1), _createElementVNode("div", _hoisted_6, _toDisplayString(detail.value.time), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_svg_icon, {
            name: (_currentData$value = currentData.value) !== null && _currentData$value !== void 0 && _currentData$value.isLike ? 'icon-black-lick' : 'icon-red-star',
            class: "icon",
            size: 14,
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleLike(currentData.value);
            })
          }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString(currentData.value.likeCount), 1)])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(ChevronLeftCircleIcon), {
            size: "20px",
            class: "left-icon",
            onClick: handlePre
          }), _createVNode(_unref(ChevronRightCircleIcon), {
            size: "20px",
            class: "left-icon",
            onClick: handleNext
          })])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};